<template>
  <div class="max-w-lg mx-auto">
    <h1>Order a box of cupcakes</h1>
    <div class="mb-4 text-sm px-2" v-html="compiledMarkdown"></div>
  <GroupChoice v-model="group" :groups="groups" />
  <div id="box"></div>
  <ProductChoice :group="group" v-model="sku" v-if="group" />


  <template v-if="!hideFlavours">
    <div id="flavours"></div>
    <FlavourChoice v-model="letMeChoose" v-if="group && sku" :sku="sku" />
    <div id="picker"></div>
    <template v-if="group && sku && letMeChoose">
      <FlavourPicker v-model="chosenFlavours" :sku="sku" />
      <Box :sku="sku" :flavours="chosenFlavours" />
    </template>
  </template>

  <div class="mb-8" v-if="hideFlavours && group && sku && false">
    <label class="text-sm text-left mr-2">
      <input type="checkbox" v-model="topper">
      Include a Thank You Topper
    </label>
  </div>

  <div class="mb-8" v-if="hideFlavours && group && sku">
    <label class="text-sm text-left mr-2">
      <input type="checkbox" v-model="bacon">
      No Maple Bacon please!
    </label>
  </div>

  <div v-if="group && sku" class="px-4">
    <item-summary :sku="sku" :chosenFlavours="chosenFlavours" :topper="topper" :bacon="bacon" />
    <button @click.prevent="addToBasket"
      class="bg-jblue py-4 px-4 block w-full uppercase font-proxima text-white">
      {{id ? "Update order" : `Add to basket`}}
    </button>
  </div>
  </div>
</template>

<script>

import { find, remove, slice } from 'lodash'
import marked from 'marked';
import GroupChoice from '../components/GroupChoice';
import ProductChoice from '../components/ProductChoice';
import FlavourChoice from '../components/FlavourChoice';
import FlavourPicker from '../components/FlavourPicker';
import Box from '../components/Box';
import ItemSummary from '../components/ItemSummary';
import lscache from 'lscache';

export default {
  props: {
    value: {}, 
    defaultGroups: {},
  },
  data() {
    return {
      group: null,
      sku: null,
      id: null,
      chosenFlavours: [],
      topper: false,
      bacon: false,
      letMeChoose: false,
      groups: this.defaultGroups
    }
  },
  components: {
    GroupChoice,
    ProductChoice,
    FlavourChoice,
    FlavourPicker,
    Box,
    ItemSummary
  },
  methods: {
    addToBasket() {
      let basket = []
      if(lscache.get('basket')) {
        try {
          basket = lscache.get('basket')
          if(!basket) {
            basket = []
          }
        } catch(e) {
          basket = []
        }
      }

      if(this.id) {
        remove(basket, {id: this.id})
      } else {
        const product = find(this.$root.$data.products, {sku: this.sku})
        window.gtag('event','add_to_cart', {
          currency: "GBP",
          items: [{
            id: product.sku,
            quantity: 1,
            price: product.amount,
            name: product.name
          }]
        })
      }

      basket.push({
        sku: this.sku,
        flavours: this.chosenFlavours,
        topper: this.topper,
        bacon: this.bacon,
        cupcake: true,
        id: this.id ? this.id : new Date().getTime().toString()
      })

      lscache.set('basket', basket, 60 * 24 * 3)

      this.$router.push({name: 'basket'})

    }
  },
  computed: {

    special() {
      let found = false

      if(this.groups && this.groups.length > 1) {
        this.groups.map((group) => {
          if(["fathers-mini","fathers-big","halloween-mini","halloween-big","christmas-mini","christmas-big","valentines-mini","valentines-big","mothers-mini","mothers-big"].includes(group)) {
            found = true
          }
        })
      }
      return found

    },

    compiledMarkdown() {
      if(this.special) {
        return marked(this.$root.$data.images.cupcake_intro_special)
      } else {
        return marked(this.$root.$data.images.cupcake_intro)
      }
    },
    hideFlavours() {
      return ["fathers-mini","fathers-big","halloween-mini","halloween-big","christmas-mini","christmas-big","valentines-mini","valentines-big","mothers-mini","mothers-big"].includes(this.group)
    }
  },
  mounted() {

    if(this.$router.currentRoute.name == "edit-cupcakes") {
      const basket = lscache.get('basket')
      const item = find(basket, {id: this.$router.currentRoute.params.id})
      const product = find(this.$root.$data.products, {sku: item.sku})

      this.group = product.group
      this.topper = item.topper
      this.bacon = item.bacon

      if(product.group.includes("fathers-mini") || product.group.includes("fathers-big")) {
        this.groups = ['fathers-mini','fathers-big']
        this.special = true
      }
      if(product.group.includes("halloween-mini") || product.group.includes("halloween-big")) {
        this.groups = ['halloween-mini','halloween-big']
        this.special = true
      }
      if(product.group.includes("christmas-mini") || product.group.includes("christmas-big")) {
        this.groups = ['christmas-mini','christmas-big']
        this.special = true
      }
      if(product.group.includes("valentines-mini") || product.group.includes("valentines-big")) {
        this.groups = ['valentines-mini','valentines-big']
        this.special = true
      }
      if(product.group.includes("monthers-mini") || product.group.includes("monthers-big")) {
        this.groups = ['monthers-mini','monthers-big']
        this.special = true
      }

      this.sku = product.sku
      if(item.flavours.length) {
        this.letMeChoose = true
        this.chosenFlavours = item.flavours
      }
      this.id = item.id
    }
  },
  watch: {
    group(newItem, oldItem) {
      if(oldItem) {
        this.sku = null
      }
    },
    letMeChoose() {
      if(!this.letMeChoose) {
        this.chosenFlavours = []
      }
    },
    sku() {
      const product = find(this.$root.$data.products, {sku: this.sku})
      this.chosenFlavours = slice(this.chosenFlavours, 0, product.slots)
    }
  },  
  head: {
    title() {
      return {
        inner: "Cupcakes"
      }
    }
  }
}
</script>
